export {default as path} from "./src/path";



//////////////////
// WEBPACK FOOTER
// ./packages/element/node_modules/d3-path/index.js
// module id = 13
// module chunks = 0